export const fr = {
  "toastMessages.successLogin": "Connexion réussie",
  "toastMessages.successLoginDescription": "Bon retour !",
  "toastMessages.failedLogin": "Échec de la connexion",
  "toastMessages.failedLoginDescription":
    "Veuillez vérifier vos identifiants et réessayer.",

  // Api Call
  "toastMessages.failedApiCall": "Échec de l'appel API avec le statut",

  //Master Call
  "toastMessages.failedLLMModelsMasterCall": "Échec de la récupération des modèles LLM",
  "toastMessages.failedEmbeddingModelsMasterCall": "Échec de la récupération des modèles d'embedding",

  // Load Templates
  "toastMessages.failedLoadTemplates": "Échec du chargement des modèles",
  "toastMessages.noTemplates": "Aucun modèle trouvé",

  // Create Template
  "toastMessages.failedCreateTemplate": "Échec de la création du modèle",
  "toastMessages.failedCreateTemplateWithStatus":
    "Échec de la création du modèle : {status}",
  "toastMessages.failedFetchTemplate": "Échec de la récupération des modèles",
  "toastMessages.failedFetchAgent": "Échec de la récupération des agents",
  "toastMessages.templatesLoadedSuccess": "Modèles chargés avec succès",
  "toastMessages.templateCreatedSuccess": "Modèle créé avec succès",

  // Update Template
  "toastMessages.failedUpdateTemplate": "Échec de la mise à jour du modèle",
  "toastMessages.failedUpdateTemplateWithStatus":
    "Échec de la mise à jour du modèle : {status}",
  "toastMessages.templateUpdatedSuccess": "Modèle mis à jour avec succès",

  // Delete Template
  "toastMessages.failedDeleteTemplate": "Échec de la suppression du modèle",
  "toastMessages.failedFetchOrganizations":
    "Échec de la récupération des organisations",
  "toastMessages.failedDeleteTemplateWithStatus":
    "Échec de la suppression du modèle : {status}",
  "toastMessages.templateDeletedSuccess": "Modèle supprimé avec succès",

  // Delete Knowledge Base
  "toastMessages.failedDeleteKnowledge":
    "Échec de la suppression de la base de connaissances",
  "toastMessages.knowledgeDeletedSuccess":
    "Base de connaissances supprimée avec succès",

  // Knowledge Base
  "toastMessages.failedLoadKnowledgeUnexpectedFormat":
    "Échec du chargement des bases de connaissances : format de données inattendu.",
  "toastMessages.failedLoadKnowledgeUnexpectedError":
    "Échec du chargement des bases de connaissances : erreur inattendue.",
  "toastMessages.failedAddKnowledge":
    "Échec de l'ajout de la base de connaissances",
  "toastMessages.failedUpdateKnowledge":
    "Échec de la mise à jour de la base de connaissances",
  "toastMessages.failedFetchKnowledge":
    "Échec de la récupération des bases de connaissances",
  "toastMessages.failedFetchKnowledgeByRole":
    "Échec de la récupération des bases de connaissances par rôle",
  "toastMessages.knowledgeAddedSuccess":
    "Base de connaissances ajoutée avec succès !",
  "toastMessages.knowledgeUpdateSuccess":
    "Base de connaissances mise à jour avec succès!",
  "toastMessages.knowledgeProcessing":
    "La base de connaissances est actuellement en cours de traitement.",
  "toastMessages.knowledgeNotSelected": "Aucune connaissance sélectionnée",
  "labels.knowledgeBaseHint": "Si aucune base de connaissances n’est sélectionnée, toutes les bases de connaissances disponibles seront utilisées pour générer la réponse.",
  "toastMessages.knowledgeLoadedSuccess": "Bases de connaissances chargées avec succès",
  "toastMessages.knowledgeCreatedSuccess": "Connaissance créée avec succès",
  "toastMessages.knowledgeCreatedSuccessDescription":
    "L’élément de connaissance a été ajouté avec succès.",
  "toastMessages.knowledgeUpdatedSuccess":
    "Connaissance mise à jour avec succès",
  "toastMessages.knowledgeUpdatedSuccessDescription":
    "L’élément de connaissance a été mis à jour avec succès.",
  "toastMessages.failedCreateKnowledge":
    "Échec de la création de la connaissance",
  "toastMessages.failedCreateKnowledgeDescription":
    "Une erreur est survenue lors de la création. Veuillez réessayer.",
  "toastMessages.failedUpdateKnowledgeDescription":
    "Une erreur est survenue lors de la mise à jour. Veuillez réessayer.",

  // Agent
  "toastMessages.failedAddAgent": "Échec de l'ajout de l'agent",
  "toastMessages.failedDeleteAgent": "Échec de la suppression de l'agent",
  "toastMessages.failedUpdateAgent": "Échec de la mise à jour de l'agent",
  "toastMessages.failedFetchAgents": "Échec de la récupération des agents",
  "toastMessages.failedFetchAgentDetails":
    "Échec du chargement des détails de l’agent",
  "toastMessages.failedFetchGroups": "Échec de la récupération des groupes",
  "toastMessages.agentAddedSuccess": "Agent ajouté avec succès!",
  "toastMessages.agentUpdatedSuccess": "Agent mis à jour avec succès!",
  "toastMessages.agentDeletedSuccess": "Agent supprimé avec succès!",
  "toastMessages.agentsLoadedSuccess": "Agents chargés avec succès",

  // Query Library
  "toastMessages.failedLoadQueries": "Échec du chargement des requêtes",
  "toastMessages.unableToFetchQueries": "Impossible de récupérer les requêtes",
  "toastMessages.queriesLoadedSuccess": "Requêtes chargées avec succès",
  "toastMessages.failedCreateQuery": "Échec de la création de la requête",
  "toastMessages.fillAllRequiredFieldsDescription":
    "Veuillez remplir tous les champs obligatoires",
  "toastMessages.queryCreatedSuccess": "Requête créée avec succès",
  "toastMessages.failedUpdateQuery": "Échec de la mise à jour de la requête",
  "toastMessages.queryUpdatedSuccess": "Requête mise à jour avec succès",
  "toastMessages.failedDeleteQuery": "Échec de la suppression de la requête",
  "toastMessages.queryDeletedSuccess": "Requête supprimée avec succès",
  //Conversation History
  "toastMessages.failedtoFetchConversationHistory":
    "Échec du chargement de l’historique des conversations",
  "toastMessages.failedtoFetchConversationHistoryById":
    "Échec du chargement de l’historique des conversations",
  "toastMessages.failedtoDeleteConversationHistory":
    "Échec de la suppression de l’historique de conversation",
  "toastMessages.failedToSendMessage": "Échec de l'envoi du message",
  //Agents
  "toastMessages.failedtoFetchAgentsList":
    "Échec de la récupération des agents",
  //KnowledgeBase
  "toastMessages.failedtoKnowledgeBaseList":
    "Échec de la récupération des bases de connaissances",
  //Prompt Template
  "toastMessages.failedToFetchPromptTemplates":
    "Échec de la récupération des modèles d'invite",
  //Chat
  "toastMessages.failedToFetchChatResponse":
    "Échec de la récupération de la réponse du chat",
  "toastMessages.failedtoAddFeedback":
    "Échec de l'ajout du retour d'expérience",
  "toastMessages.failedToUpdateFeedback":
    "Échec de la mise à jour du retour d'expérience",
  // Performance
  "toastMessages.performanceDataLoadedSuccess": "Données de performance chargées avec succès",
  // RAI Metrics
  "toastMessages.raiMetricsLoadedSuccess": "Métriques RAI chargées avec succès",
  //Governance Metrics
  "toastMessages.governanceMetricsLoadedSuccess":
    "Métriques de gouvernance chargées avec succès",
  "toastMessages.failedToFetchGovernanceMetrics":
    "Échec du chargement des métriques de gouvernance",
  //User adoption Insight
  "toastMessages.analyticsDataRefreshed": "Données d'analyse actualisées",
  "toastMessages.userAdoptionInsightsLoadedSuccess":
    "Aperçus du projet chargés avec succès",
  "toastMessages.failedUserAdoptionInsightsLoaded":
    "Échec du chargement des aperçus du projet",
  //Feedback Report
  "toastMessages.failedLoadFeedback": "Échec du chargement des retours",
  "toastMessages.feedbackLoadedSuccess": "Retours chargés avec succès",

  // Validation Messages
  "toastMessages.validationBasicSettings":
    "Veuillez remplir tous les champs obligatoires dans les paramètres de base.",
  "toastMessages.validationSelectFile":
    "Veuillez sélectionner au moins un fichier pour le type de source Document.",
  "toastMessages.validationWebUrl":
    "Veuillez fournir une URL Web pour le type de source URL Web.",
  "toastMessages.validationError": "Erreur de validation",
  "toastMessages.summarizerError": "Erreur du résumeur",
  "toastMessages.summarizerRequestFailed": "Échec de la requête du résumeur",
  "toastMessages.failedDelete": "Échec de la suppression",

  // Group Management
  "toastMessages.groupDeleted": "Groupe supprimé",
  "toastMessages.groupUpdated": "Groupe mis à jour",
  "toastMessages.groupCreated": "Groupe créé",
  "toastMessages.subgroupCreated": "Sous-groupe créé",

  // Auth Provider
  "toastMessages.sessionExpired": "Session expirée",
  "toastMessages.sessionExpired.description": "Veuillez vous reconnecter",
  "toastMessages.failedStoredAuth":
    "Échec de l'analyse de l'authentification stockée",
  "toastMessages.invalidCredentails": "Identifiants invalides",
  "toastMessages.useAuthOutsideProvider":
    "useAuth doit être utilisé dans un AuthProvider",

  "toastMessages.useThemeProvider":
    "useTheme doit être utilisé dans un ThemeProvider",

  "toastMessages.fetchConversationError":
    "Erreur lors de la récupération des données de conversation.",

  "toastMessages.routeNotFound": "Erreur 404 : Page non trouvée",
  "toastMessages.routeDescription": "Tentative d'accès à : ",

  "toastMessages.notFoundCode": "404",
  "toastMessages.notFoundMessage": "Oups ! Page introuvable",
  "toastMessages.returnHome": "Retour à l'accueil",

  "toastMessages.fixFormErrors":
    "Veuillez corriger les erreurs du formulaire avant d'enregistrer",
  "toastMessages.multipleRolesCommaSeperated":
    "(séparés par des virgules pour plusieurs rôles)",
  "toastMessages.multipleTasksCommaSeperated":
    "(séparées par des virgules pour plusieurs tâches)",

  "toastMessages.templateNotFound":
    "Aucun modèle trouvé. Créez votre premier modèle pour commencer !",
  "toastMessages.knowledgeNotFound":
    "Aucune base de connaissances trouvée. Créez votre première base de connaissances pour commencer !",

  "toastMessages.noPermission":
    "Vous n'avez pas l'autorisation d'accéder à cette ressource.",
  "toastMessages.accessDenied": "Accès refusé",
  "toastMessages.returnDashboard": "Retour au tableau de bord",

  "toastMessages.settingsSaved": "Paramètres enregistrés",
  "toastMessages.settingsUpdated": "Les paramètres ont été mis à jour.",
  "toastMessages.deleteYourself": "Impossible de vous supprimer vous-même",
  "disclaimer.changesTitle":
    "Modifications affectant le comportement de l'agent",
  "disclaimer.changesDescription":
    "La modification des groupes affecte l'affichage des agents. La mise à jour des bases de connaissances peut modifier les réponses des agents. Voulez-vous continuer ?",
  "disclaimer.changesDescription.systemAdmin":
    "La modification des organisations ou des groupes affecte l'affichage des agents. La mise à jour des bases de connaissances peut modifier les réponses des agents. Voulez-vous continuer ?",
  "disclaimer.changesDescription.orgAdmin":
    "La modification des groupes affecte l'affichage des agents. La mise à jour des bases de connaissances peut modifier les réponses des agents. Voulez-vous continuer ?",
  "toastMessages.userDeleted": "Utilisateur supprimé avec succès",
  "toastMessages.userUpdated": "Utilisateur mis à jour avec succès",
  "toastMessages.userAdded": "Utilisateur ajouté avec succès",
  "toastMessages.userCreated": "Utilisateur créé avec succès",
  "toastMessages.userNotFound": "Aucun utilisateur trouvé",
  "toastMessages.organizationListSuccess": "Les organisations ont réussi",
  "toastMessages.organizationCreateSuccess": "Organisation créée avec succès",
  "toastMessages.organizationCreateFailure":
    "Échec de la création de l'organisation",
  "toastMessages.organizationDeleteSuccess":
    "Organisation supprimée avec succès",
  "toastMessages.organizationDeleteFailure":
    "Échec de la suppression de l'organisation",
  "toastMessages.organizationListFailure":
    "Impossible de récupérer la liste des organisations",
  "toastMessages.organizationUpdateSuccess":
    "Organisation mise à jour avec succès",
  "toastMessages.organizationUpdateFailure":
    "Échec de la mise à jour de l'organisation",
  "toastMessages.logoutFailed": "Échec de la déconnexion",
  "toastMessages.sessionExtendFailed": "Échec de l'extension de session",
  "toastMessages.newPassword":
    "Nouveau mot de passe (laisser vide pour conserver l'actuel)",

  "toastMessages.chatContent":
    "Bonjour ! Comment puis-je vous aider aujourd'hui ?",

  "labels.editFeedback": "Modifier le commentaire",

  "toastMessages.deleteConfirmation": "Supprimer {{itemName}}",

  "toastMessages.groupListSuccess": "Groupes récupérés avec succès",
  "toastMessages.groupListFailure": "Impossible de récupérer les groupes",
  "toastMessages.userListSuccess": "Utilisateurs récupérés avec succès",
  "toastMessages.userListFailure": "Impossible de récupérer les utilisateurs",
  "toastMessages.userGroupSuccess":
    "Groupes d'utilisateurs récupérés avec succès",
  "toastMessages.userGroupFailure":
    "Impossible de récupérer les groupes d'utilisateurs",
  "toastMessages.groupCreateSuccess": "Groupe créé avec succès",
  "toastMessages.groupCreateFailure": "Échec de la création du groupe",
  "toastMessages.groupUpdateSuccess": "Groupe mis à jour avec succès",
  "toastMessages.groupUpdateFailure": "Échec de la mise à jour du groupe",
  "toastMessages.addUserSuccess": "Utilisateur ajouté avec succès",
  "toastMessages.addUserFailure": "Impossible d'ajouter l'utilisateur",
  "toastMessages.removeUserSuccess": "Utilisateur supprimé avec succès",
  "toastMessages.removeUserFailure": "Échec de la suppression de l'utilisateur",
  "toastMessages.groupDeleteSuccess": "Groupe supprimé avec succès",
  "toastMessages.groupDeleteFailure": "Échec de la suppression du groupe",

  "toastMessageDescriptions.failedLoadKnowledgeUnexpectedFormat":
    "Le serveur a renvoyé une structure de réponse inattendue.",
  "toastMessageDescriptions.failedLoadKnowledgeUnexpectedError":
    "Une erreur inattendue est survenue lors du chargement des bases de connaissances. Veuillez réessayer.",
  "toastMessageDescriptions.summarizerError":
    "La synthèse a échoué. Vérifiez votre URL ou votre fichier et réessayez.",
  "toastMessageDescriptions.summarizerRequestFailed":
    "Une erreur est survenue lors de la demande de synthèse. Veuillez réessayer plus tard.",
  "toastMessageDescriptions.unknownError":
    "Un problème est survenu. Veuillez réessayer.",
  "toastMessageDescriptions.successLoginDescription": "Bon retour parmi nous !",
  "toastMessageDescriptions.failedLoginDescription":
    "Veuillez vérifier vos identifiants et réessayer.",
  "toastMessageDescriptions.deleteDescription":
    "Cette action est irréversible. Cela supprimera définitivement l’élément sélectionné.",
  "toastMessages.promptGuidanceSuccess":
    "Guidance de prompt récupérée avec succès",
  "toastMessages.promptGuidanceFailure":
    "Échec de la récupération de la guidance de prompt",
  "toastMessages.promptGuidanceDeleteSuccess":
    "Guidance de prompt supprimée avec succès",
  "toastMessages.promptGuidanceDeleteFailure":
    "Échec de la suppression de la guidance de prompt",
  "toastMessages.promptGuidanceCreateSuccess":
    "Guidance de prompt créée avec succès",
  "toastMessages.promptGuidanceCreateFailure":
    "Échec de la création de la guidance de prompt",
  "toastMessages.promptGuidanceUpdateSuccess":
    "Guidance de prompt mise à jour avec succès",
  "toastMessages.promptGuidanceUpdateFailure":
    "Échec de la mise à jour de la guidance de prompt",
  "toastMessages.genericError": "Une erreur est survenue. Veuillez réessayer.",
  "toastMessages.noOrganizationFound":
    "Aucune organisation trouvée. Veuillez d’abord créer une organisation.",
  "toastMessages.fetchOrganizationFailed":
    "Échec de la récupération des organisations",
  "toastMessages.failedLoadGroups": "Échec de la récupération des groupes",
  "toastMessages.failedLoadDetails": "Échec de la récupération des détails",
  "toastMessages.failedLoadVersions": "Échec de la récupération des versions",
  "toastMessages.noGroupFound": "Aucun groupe trouvé",
  "toastMessages.createGroupFirst":
    "Veuillez créer un groupe avant d’attribuer un administrateur de groupe",
  "toastMessages.fetchGroupFailed": "Échec de la récupération des groupes",
  "toastMessages.userCreateFailed": "Échec de la création de l’utilisateur",
  "toastMessages.userUpdateFailed": "Échec de la mise à jour de l’utilisateur",
  "toastMessages.userDeleteFailed": "Échec de la suppression de l’utilisateur",
  "toastMessages.fetchUserFailed": "Échec de la récupération de l'utilisateur",
  "toastMessages.notAllowed": "Action non autorisée",
  "toastMessages.cannotEditOrgAdmin": "Modification non autorisée",
  "toastMessages.invalidDateRange": "Plage de dates invalide",
  "toastMessages.invalidDateRangeDescription":
    "La date de début ne peut pas être postérieure à la date de fin.",

  "templateDescriptions.nameDescription":
    "Donnez à votre modèle un nom clair et descriptif",
  "templateDescriptions.versionDescription":
    "Entrez le numéro de version pour ce modèle",
  "templateDescriptions.roleDescription":
    "Définissez le rôle et l’expertise de l’IA",
  "templateDescriptions.taskDescription": "Que doit accomplir l’IA ?",
  "templateDescriptions.requirementsDescriptions":
    "Précisez les prérequis ou conditions",
  "templateDescriptions.detailsDescription":
    "Contexte supplémentaire et spécifications",
  "templateDescriptions.restrictionDescription":
    "Définissez les limitations et contraintes",
  "templateDescriptions.formatDescription":
    "Précisez la structure de sortie souhaitée",
  "templateDescriptions.exampleDescription":
    "Fournissez des exemples pour guider la compréhension de l’IA",
  "templateDescriptions.temperatureDescription":
    "Définissez la température du modèle (0-1)",
  "templateDescriptions.topPDescription":
    "Définissez la probabilité d'échantillonnage du noyau (0-1)",
  "templateDescriptions.topKDescription": "Définissez la probabilité d'échantillonnage top-k",
  "templateDescriptions.maxInputTokensDescription":
    "Nombre maximum de tokens autorisés pour l'entrée",
  "templateDescriptions.maxOutputTokensDescription":
    "Nombre maximum de tokens autorisés pour la sortie",
  "templateDescriptions.stopSequenceDescription":
    "Séquence pour arrêter la génération",
  "templateDescriptions.organizationSelect":
    "Sélectionnez une ou plusieurs organisations pour le modèle",
  "templateDescriptions.groupSelect": "Choisissez les groupes pour le modèle",
  "placeholders.organizationName": "Entrez le nom de l'organisation",
  "placeholders.name": "Ex. Chatbot",
  "placeholders.version": "1",
  "placeholders.role": "Sélectionner un rôle",
  "placeholders.task":
    "Veuillez fournir un aperçu clair et complet de ce que l'IA peut accomplir aujourd'hui et de ses capacités futures potentielles.",
  "placeholders.requirements":
    "Fournissez clairement les exigences sous forme de puces. Limitez votre réponse à 300 mots.",
  "placeholders.details":
    "Répondez en français avec un ton formel, respectueux et approprié pour une communication académique.",
  "placeholders.restrictions":
    "Évitez les suppositions, le contenu grossier ou nuisible, et gardez la réponse neutre et factuelle.",
  "placeholders.format":
    "Présentez clairement le résultat sous forme de tableau, avec des en-têtes et des lignes appropriés inclus.",
  "placeholders.examples":
    "Entrée : Salut John, pouvons-nous reprogrammer notre réunion pour vendredi au lieu de jeudi ?\nSortie attendue : Salut ! Bien sûr, vendredi me convient. À quelle heure êtes-vous disponible ?",
  "placeholders.groupName": "Saisir le nom du groupe",
  "placeholders.description": "Saisir la description",
  "placeholders.noGroup": "Aucun groupe trouvé",
  "placeholders.search": "Rechercher…",
  "placeholders.knowledgeName": "Ex. Document de politique de l'entreprise",
  "placeholders.selectChatType": "Sélectionner le type de chat...",
  "placeholders.selectSourceType": "Sélectionner le type de source...",
  "placeholders.selectTemplate": "Sélectionner le modèle...",
  "placeholders.selectAgent": "Sélectionner Agent",
  "placeholders.selectKnowledgeBase": "Sélectioner Knowledge Base",
  "placeholders.selectPromptTemplate": "Sélectionner un modèle de prompt",
  "placeholders.selectPromptTemplates": "Sélectionner Prompts",
  "placeholders.webUrl": "https://exemple.com",
  "placeholders.temperature": "0.0",
  "placeholders.maxTokens": "2000",
  "placeholders.selectEmbeddingType": "Sélectionner un fournisseur...",
  "placeholders.selectEmbeddingModel": "Sélectionner le modèle...",
  "placeholders.selectModel": "Sélectionner un modèle",
  "placeholders.selectLlmType": "Sélectionner le type...",
  "placeholders.selectLlmModel": "Sélectionner le modèle...",
  "placeholders.selectApp": "Sélectionner l'application",
  "placeholders.selectGroups": "Sélectionner des groupes...",
  "placeholders.askKnowledgeBase":
    "Poser une question pour tester la base de connaissances...",
  "placeholders.responseAppear": "La réponse apparaîtra ici...",
  "placeholders.selectOrganization": "Sélectionner une organization",
  "placeholders.selectRole": "Sélectionner un rôle",
  "placeholders.agentName": "Saisir le nom de l'agent",
  "placeholders.selectKnowledge": "Sélectionner la connaissance...",
  "placeholders.typeMessage": "Saisir votre message...",
  "placeholders.typeMessageReady": "Saisir un message",
  "placeholders.selectAgentToStartChatting": "Sélectionnez un agent pour commencer à discuter",
  "placeholders.chatFieldNotSelected": "{{field}} n'est pas sélectionné.",
  "placeholders.chatFieldsNotSelected": "{{fields}} ne sont pas sélectionnés.",
  "placeholders.rolePlaceholder": "ADMIN, UTILISATEUR, MODÉRATEUR",
  "placeholders.taskPlaceholder": "Assistant, Aide, Analyseur",
  "placeholders.documentSummary": "Entrez le résumé du document...",
  "placeholders.departmentName": "Entrez le nom du département",
  "placeholders.userID": "Entrez Identifiant utilisateur",
  "placeholders.userName": "Entrez le nom complet",
  "placeholders.documentNumber": "Entrez le numéro du document",
  "placeholders.topP": "0,0",
  "placeholders.topK": "1",
  "placeholders.maxInputTokens": "2000",
  "placeholders.maxOutputTokens": "2000",
  "placeholders.stopSequence": "Entrez la séquence d'arrêt",
  "placeholders.selectCategory": "Sélectionnez une catégorie..",
  "placeholders.keywords": "ex. prêt, logement, échéance",
  "placeholders.queryText": "Saisissez le texte de la requête",
  "placeholders.queryName": "Saisissez le nom de la requête",
  "placeholder.queryLibrary": "Questions bancaires fréquemment posées",
  "placeholders.searchFeedback": "Rechercher un retour...",
  "placeholders.selectKnowledgeBases":
    "Sélectionner des bases de connaissances",
  "placeholders.organizationId": "Entrez l'ID de l'organisation",
  "placeholders.groupId": "Entrez l'ID du groupe",
  "placeholders.firstName": "Entrez le prénom",
  "placeholders.lastName": "Entrez le nom",
  "placeholders.email": "Entrez l’adresse email",
  "placeholders.password": "Entrez le mot de passe",
  "placeholders.organization": "Sélectionner une organization",
  "placeholders.group": "Sélectionner un groupe",
  "placeholders.selectOrganizations": "Sélectionner l'organisation",
  "placeholders.selectGroup": "Sélectionner le groupe",

  "labels.addKnowledge": "Ajouter une connaissance",
  "labels.updateKnowledge": "Mettre à jour les connaissances",
  "labels.updateAgent": "Mettre à jour l'agent",
  "labels.knowledgeName": "Nom du document",
  "labels.agents": "Agents",
  "labels.chatType": "Type de chat",
  "labels.sourceType": "Type de source",
  "labels.roles": "Rôles",
  "labels.promptTemplate": "Modèle d'invite",
  "labels.agent": "Agent",
  "titles.agentsSubtitle": "Construire et gérer des assistants IA conversationnels.",
  "titles.chatInterfaceSubtitle": "Posez des questions et interagissez avec vos assistants IA.",
  "titles.performanceDashboardSubtitle": "Surveillez et évaluez la qualité et la latence des réponses IA.",
  "titles.userAdoptionInsightsSubtitle": "Suivez l'engagement et les tendances d'adoption des utilisateurs sur la plateforme.",
  "labels.knowledgeBase": "Base de connaissances",
  "labels.document": "Document",
  "labels.retry": "Réessayer",
  "titles.knowledgeSubtitle":
    "Gérez les documents et les données pour votre IA.",
  "titles.promptTemplatesSubtitle": "Créer et gérer des modèles d'invite pour des interactions IA cohérentes.",
  "labels.scrapeHyperlinks": "Extraire les hyperliens",
  "labels.documentSummary": "Résumé du document",
  "labels.embeddingLLM": "Fournisseur de modèle d'embedding",
  "labels.embeddingModel": "Nom du modèle d'intégration",
  "labels.confirm": "Confirm",
  "labels.llmType": "Type de modèle LLM",
  "labels.llmModel": "Nom du modèle LLM",
  "labels.temperature": "Température",
  "labels.maxTokens": "Jetons max",
  "labels.tableName": "Nom",
  "labels.tableChatType": "Type de chat",
  "labels.tableSource": "Source",
  "labels.tableFilesUrl": "Fichiers / URL",
  "labels.tableActions": "Actions",
  "labels.loading": "Chargement...",
  "labels.loadingMessage": "Chargement des bases de connaissances...",
  "labels.loadingAgents": "Chargement des agents...",
  "labels.processing": "En cours de traitement...",
  "labels.agentName": "Nom de l'agent",
  "labels.groups": "Groupes",
  "labels.noEntriesFound": "Aucune entrée trouvée.",
  "labels.edit": "Modifier",
  "labels.delete": "Supprimer",
  "labels.detailsTitle": "Détails",
  "labels.fieldKnowledgeName": "Nom de la connaissance",
  "labels.fieldChatType": "Type de chat",
  "labels.fieldSourceType": "Type de source",
  "labels.fieldRoles": "Rôles",
  "labels.fieldEmbeddingLLMType": "Type LLM d'intégration",
  "labels.fieldEmbeddingModelName": "Nom du modèle d'intégration",
  "labels.fieldLLMModelType": "Type de modèle LLM",
  "labels.fieldLLMModelName": "Nom du modèle LLM",
  "labels.fieldTemperature": "Température",
  "labels.fieldMaxTokens": "Jetons max",
  "labels.fieldPromptTemplate": "Modèle d'invite",
  "labels.fieldAgent": "Agent",
  "labels.viewUsers": "Afficher les utilisateurs",
  "labels.fieldFilesUrl": "Fichiers / URL",
  "labels.noUsersSelected": "Aucun utilisateur trouvé",
  "labels.noUsersMatchSearch":
    "Aucun utilisateur ne correspond à votre recherche",
  "labels.tooltipAddRootGroup": "Ajouter un groupe racine",
  "labels.tableHeaderGroupName": "Nom du groupe",
  "labels.description": "Description",
  "labels.tableHeaderUsers": "Utilisateurs",
  "labels.tableHeaderCreatedAt": "Créé le",
  "labels.tableHeaderStatus": "Statut",
  "labels.tableHeaderAction": "Action",
  "labels.tooltipAddSubgroup": "Ajouter un sous-groupe",
  "labels.recordId": "ID d'enregistrement",
  "labels.timestamp": "Horodatage",
  "labels.input": "Entrée",
  "labels.output": "Sortie",
  "labels.performance": "Performance",
  "labels.detailedMetrics": "Métriques détaillées",
  "labels.latency": "Latence",
  "labels.viewFull": "Voir en entier",
  "labels.collapse": "Réduire",
  "labels.showMore": "Afficher plus",
  "labels.showLess": "Afficher moins",
  "labels.collapseChatSidebar": "Réduire la barre latérale du chat",
  "labels.expandChatSidebar": "Développer la barre latérale du chat",
  "labels.appName": "Nom de l'application :",
  "labels.totalQueries": "Nombre total de requêtes",
  "labels.lowercaseQueries": "requêtes",
  "labels.averageLatency": "Latence moyenne",
  "labels.totalTokens": "Nombre total de jetons",
  "labels.totalCost": "Coût total",
  "labels.records": "Enregistrements",
  "labels.timeStamp": "Horodatage",
  "labels.knowledgeBaseDetails": "Détails de la base de connaissances",
  "labels.inferenceModel": "Modèle d'inférence",
  "labels.provider": "Fournisseur",
  "labels.model": "Modèle",
  "labels.groupName": "Nom du groupe",
  "labels.groupDescription": "Description",
  "labels.tabGroups": "Détails du groupe",
  "labels.tabUsers": "Utilisateurs",
  "labels.inValidFileType": "Types de fichiers autorisés : .pdf, .doc, .docx",
  "labels.dropFilesHere": "Déposez les fichiers ici",
  "labels.sortBy": "Trier par : ",
  "labels.name": "Nom",
  "labels.newFirst": "Le plus récent en premier",
  "labels.oldFirst": "Le plus ancien en premier",
  "labels.departmentName": "Nom du département",
  "labels.userID": "Identifiant utilisateur",
  "labels.userName": "Nom de l'utilisateur",
  "labels.documentNumber": "Numéro du document",
  "labels.documentDate": "Date du document",
  "labels.category": "Catégorie",
  "labels.query": "Requête",
  "labels.queries": "Requêtes",
  "labels.noQueriesFound": "Aucune requête trouvée. Créez votre première requête pour commencer !",
  "labels.noQueriesFoundReadOnly": "Aucune requête trouvée.",
  "labels.chat": "Chat",
  "labels.searchQueries": "Rechercher des requêtes...",
  "labels.queryTags": "Balises de requête",
  "labels.queryName": "Nom de la requête",
  "labels.queryContent": "Contenu de la requête",
  "labels.governanceDescription":
    "Surveillez les métriques de réponse et la conformité en temps réel",
  "labels.governanceBadge": "Surveillance en temps réel",
  "labels.average": "Moyenne",
  "labels.maximum": "Maximum",
  "labels.comingSoon": "Bientôt disponible",
  "labels.userAdoptionInsightsDescription":
    "Analyse des sentiments et des comportements",
  "labels.featureIndevelopment": "Fonctionnalité en cours de développement",
  "labels.piiDescription":
    "Surveillance des informations personnelles identifiables",
  "labels.hapDescription":
    "Surveillance des propos haineux, abusifs et profanes",
  "labels.piiMetrics": "Métriques PII",
  "labels.hapMetrics": "Métriques HAP",
  "labels.inputSentimentAnalysis": "Analyse du sentiment d'entrée",
  "labels.inputSentimentAnalysisDescription": "Analyse des messages entrants",
  "labels.outputSentimentAnalysis": "Analyse du sentiment de sortie",
  "labels.outputSentimentAnalysisDescription":
    "Analyse des messages de réponse",
  "labels.feedbackUserName": "Nom d'utilisateur",
  "labels.feedbackUserPF": "Utilisateur PF",
  "labels.feedbackQuery": "Question de l'utilisateur",
  "labels.feedbackResponse": "Réponse",
  "labels.feedbackSourceRef": "Référence source",
  "labels.feedbackType": "Type de retour",
  "labels.feedbackRating": "Évaluation",
  "labels.feedbackComments": "Commentaires",
  "labels.veryGood": "Très bon",
  "labels.good": "Bon",
  "labels.ok": "OK",
  "labels.partialOk": "Partiellement OK",
  "labels.notSatisfied": "Pas satisfait",
  "labels.positiveFeedback": "commentaires positifs",
  "labels.negativeFeedback": "commentaires négatifs",
  "labels.positive": "Positif",
  "labels.removeUser": "Supprimer un utilisateur",
  "labels.group.orgAdminProvision":
    "Vous pouvez créer, mettre à jour, supprimer, consulter et lister des groupes, et ajouter ou retirer des utilisateurs des groupes.",
  "labels.group.grpAdminProvision":
    "Vous pouvez consulter et lister vos groupes, mettre à jour vos propres groupes, et ajouter ou retirer des utilisateurs de ceux-ci.",
  "labels.group.userProvision":
    "Vous pouvez uniquement consulter vos propres groupes.",
  "labels.negative": "Négatif",
  "labels.accuracyScore": "Score de précision",
  "labels.allfeedback": "Tous les retours",
  "labels.feedbackSubtitle":
    "Surveillez et analysez les retours des utilisateurs sur toutes les interactions",
  "labels.noResultsFound": "Aucun retour trouvé",
  "labels.liveUsers": "Utilisateurs en direct",
  "labels.liveQueries": "Requêtes en direct",
  "labels.peakUsers": "Utilisateurs au pic",
  "labels.peakQueries": "Requêtes au pic",
  "labels.total": "Total",
  "labels.organization.sysAdminProvision":
    "Vous pouvez créer, mettre à jour, supprimer et lister les organisations, ainsi que consulter les détails des organisations.",
  "labels.organization.orgAdminProvision":
    "Vous pouvez uniquement consulter les détails de votre organisation.",
  "labels.organizationName": "Nom de l'organisation",
  "labels.success": "Succès",
  "labels.group.title": "Créez votre premier groupe",
  "labels.group.subtitle":
    "Les groupes vous aident à organiser les utilisateurs et les ressources au sein d'une organisation. Créez votre premier groupe pour commencer à gérer les accès et les autorisations.",
  "labels.noGroups": "Aucun groupe pour l'instant",
  "labels.noGroups.descrition":
    "Vous n'appartenez à aucun groupe. Les groupes vous permettent de collaborer avec d'autres utilisateurs et de partager l'accès aux agents d'IA, aux requêtes et aux configurations.",
  "labels.failed": "Échec",
  "labels.liveUsersHourly": "Utilisateurs en direct (horaire)",
  "labels.liveQueriesHourly": "Requêtes en direct (horaire)",
  "labels.avgDailyUsers": "Moyenne quotidienne des utilisateurs",
  "labels.avgDailyQueries": "Moyenne quotidienne des requêtes",
  "labels.zoneWiseActiveUsers": "Utilisateurs actifs par zone",
  "labels.verticalWiseActiveUsers": "Utilisateurs actifs par secteur",
  "labels.avgEngagementTime": "Temps moyen d'engagement (minutes)",
  "labels.scaleWiseActiveUsers": "Utilisateurs actifs par échelle",
  "labels.lastUpdated": "Dernière mise à jour:",
  "labels.addUser": "Ajouter un utilisateur",
  "labels.editUser": "Modifier l'utilisateur",
  "labels.email": "E-mail",
  "labels.password": "Mot de passe",
  "labels.newPassword":
    "Nouveau mot de passe (laisser vide pour conserver l'actuel)",
  "labels.role": "Rôle",
  "labels.organization": "Organization",
  "labels.admin": "Administrateur",
  "labels.user": "Utilisateur",
  "labels.superAdmin": "Super administrateur",
  "labels.enterCredentials":
    "Saisissez vos identifiants pour accéder à votre compte.",
  "labels.noPromptGuidanceTitle":
    "Aucune règle de guidance de prompt pour le moment",
  "labels.queryDescription": "Description de la requête",
  "labels.noPromptGuidanceSubtitle":
    "Créez votre première règle de guidance de prompt pour aider les utilisateurs à rédiger de meilleurs prompts d’IA.",
  "labels.promptGuidance.create": "Créer une guidance de prompt",
  "labels.promptGuidance.update": "Mettre à jour la guidance de prompt",
  "labels.noPromptGuidanceRulesTitle":
    "Aucune règle de guidance de prompt encore disponible",
  "labels.noPromptGuidanceRulessubtitle":
    "La guidance de prompt aide les utilisateurs à comprendre comment rédiger des prompts d’IA efficaces. Actuellement, aucune règle n’est définie pour votre compte. Seuls les administrateurs système peuvent créer, modifier ou supprimer des règles de guidance de prompt.",
  "labels.promptGuidance.heading": "Guidance de prompt",
  "labels.promptGuidance.subheading":
    "Apprenez à rédiger des prompts efficaces pour de meilleures réponses de l’IA",

  "labels.groupId": "Identifiant du groupe",
  "labels.userProfile": "Profil utilisateur",
  "labels.userProfile.manage": "Gérez les informations de votre profil",
  "labels.settings.subtitle":
    "Gérez les préférences de votre compte et l’apparence",
  "labels.settings.appearance": "Personnalisez l’apparence de l’application",
  "labels.theme": "Thème",
  "labels.language": "Langue",

  "labels.firstName": "Prénom",
  "labels.lastName": "Nom",
  "labels.citations": "Citations",
  "labels.llmReasoning": "Raisonnement LLM",
  "labels.explainability.notFound":
    "Aucune interaction ne correspond à votre recherche.",
  "labels.permissions.SystemAdmin.organization.create":
    "Créer des organisations",
  "labels.permissions.SystemAdmin.organization.update":
    "Mettre à jour les organisations",
  "labels.permissions.SystemAdmin.organization.delete":
    "Supprimer des organisations",
  "labels.permissions.SystemAdmin.organization.list":
    "Voir toutes les organisations",
  "labels.permissions.SystemAdmin.organization.view":
    "Voir les détails de l'organisation",
  "labels.permissions.SystemAdmin.user.createBootstrap":
    "Créer des utilisateurs bootstrap",

  "labels.permissions.OrgAdmin.organization.viewOwn":
    "Voir les détails de votre organisation",
  "labels.permissions.OrgAdmin.user.create": "Créer des utilisateurs",
  "labels.permissions.OrgAdmin.user.update": "Mettre à jour les utilisateurs",
  "labels.permissions.OrgAdmin.user.delete": "Supprimer des utilisateurs",
  "labels.permissions.OrgAdmin.user.list": "Voir tous les utilisateurs",
  "labels.permissions.OrgAdmin.user.view": "Voir les détails de l'utilisateur",

  "labels.permissions.OrgAdmin.group.create": "Créer des groupes",
  "labels.permissions.OrgAdmin.group.update": "Mettre à jour les groupes",
  "labels.permissions.OrgAdmin.group.delete": "Supprimer des groupes",
  "labels.permissions.OrgAdmin.group.view": "Voir les détails du groupe",
  "labels.permissions.OrgAdmin.group.list": "Voir tous les groupes",
  "labels.permissions.OrgAdmin.group.addUser":
    "Ajouter un utilisateur au groupe",
  "labels.permissions.OrgAdmin.group.removeUser":
    "Supprimer un utilisateur du groupe",

  "labels.permissions.GroupAdmin.user.updateOwnGroup":
    "Mettre à jour les utilisateurs de votre groupe",
  "labels.permissions.GroupAdmin.user.viewOwnGroup":
    "Voir les utilisateurs de votre groupe",
  "labels.permissions.GroupAdmin.user.listOwnGroup":
    "Voir tous les utilisateurs de votre groupe",

  "labels.permissions.GroupAdmin.group.update": "Mettre à jour votre groupe",
  "labels.permissions.GroupAdmin.group.view": "Voir votre groupe",
  "labels.permissions.GroupAdmin.group.list": "Voir vos groupes",
  "labels.permissions.GroupAdmin.group.addUser":
    "Ajouter des utilisateurs à un groupe",
  "labels.permissions.GroupAdmin.group.removeUser":
    "Supprimer des utilisateurs d'un groupe",

  "labels.permissions.User.group.viewOwn": "Voir votre groupe",

  "labels.access": "Vos accès",

  "labels.accessSentence":
    "En tant que {{article}} {{role}}, vous avez accès aux permissions suivantes",
  "labels.startDate": "Date de début",
  "labels.endDate": "Date de fin",
  "labels.noRAIMetricsTitle":
    "Oups ! Aucune donnée trouvée pour la période sélectionnée",
  "labels.noRAIMetricsSubtitle":
    "Il semble qu’aucune métrique RAI ne soit disponible pour cette période. Essayez de modifier les dates de début et de fin ci-dessus, puis cliquez sur « Rechercher » pour recharger les données.",
  "labels.workspace": "Espace de travail",
  "labels.newChat": "Nouvelle conversation",
  "labels.chatHistory": "Historique des discussions",
  "labels.recent": "Récent",
  "labels.settingsAndHelp": "Paramètres et aide",
  "labels.user.grpAdminProvision":
    "Vous pouvez mettre à jour, consulter et lister vos propres groupes.",
  "labels.user.orgAdminProvision":
    "Vous pouvez mettre à jour, consulter et lister vos propres groupes.",
  "labels.user.sysAdminProvision": "Gérez tous les utilisateurs à travers les organisations et les groupes.",
  "labels.toggleTheme": "Basculer le thème",
  "labels.selectLanguage": "Choisir la langue",
  "labels.editTemplate": "Mettre à jour le modèle",
  "labels.from": "De",
  "labels.to": "À",

  "alerts.unableToLoad": "Impossible de charger",
  "alerts.noHourlyUserData": "Aucune donnée utilisateur horaire disponible",
  "alerts.noHourlyQueryData": "Aucune donnée de requête horaire disponible",
  "alerts.noDailyUserData": "Aucune donnée utilisateur quotidienne disponible",
  "alerts.noDailyQueryData": "Aucune donnée de requête quotidienne disponible",
  "alerts.noZoneData": "Aucune donnée de zone disponible",
  "alerts.noVerticalData": "Aucune donnée sectorielle disponible",
  "alerts.noEngagementData": "Aucune donnée d’engagement disponible",
  "alerts.noScaleData": "Aucune donnée d’échelle disponible",
  "alerts.noInputSentimentData":
    "Aucune donnée de sentiment d’entrée disponible",
  "alerts.noOutputSentimentData":
    "Aucune donnée de sentiment de sortie disponible",
  "alerts.noHapData": "Les données de détection HAP ne sont pas disponibles",
  "alerts.noPiiData": "Les données de détection PII ne sont pas disponibles",

  "emptyStates.noLatencyData": "Aucune donnée de latence disponible pour la plage de dates sélectionnée",
  "emptyStates.noThroughputData": "Aucune donnée de débit disponible pour la plage de dates sélectionnée",
  "emptyStates.noContextDriftData": "Aucune donnée de dérive contextuelle disponible",
  "emptyStates.noResponseDriftData": "Aucune donnée de dérive de réponse disponible",
  "emptyStates.noAccuracyData": "Aucune donnée de score de précision disponible",
  "emptyStates.noRetrievalPrecisionData": "Aucune donnée de précision de récupération disponible",
  "emptyStates.dataNotFound": "Données introuvables",

  "buttons.saveChangesButton": "Enregistrer les modifications",
  "buttons.createTemplateButton": "Créer un modèle",
  "buttons.createAgentButton": "Créer un agent",
  "buttons.cancelButton": "Annuler",
  "buttons.addTemplateButton": "Ajouter un modèle",
  "buttons.backButton": "← Retour",
  "buttons.createVersionButton": "Créer une version",
  "buttons.addGroupButton": "Ajouter un groupe",
  "buttons.addSubgroupButton": "Ajouter un sous-groupe",
  "buttons.addUser": "Ajouter un utilisateur",
  "buttons.remove": "Supprimer",
  "buttons.addUserButton": "Ajouter",
  "buttons.createSubgroupButton": "Créer un sous-groupe",
  "buttons.createGroupButton": "Créer un groupe",
  "buttons.editGroupButton": "Modifier le groupe",
  "buttons.editAgentButton": "Modifier l’agent",
  "buttons.editTemplateButton": "Éditer le modèle",
  "buttons.editVersionButton": "Modifier la version",
  "buttons.addKnowledge": "Ajouter une base de connaissances",
  "buttons.addAgent": "Ajouter un agent",
  "buttons.basicSettingsTab": "Paramètres de base",
  "buttons.create": "Créer",
  "buttons.advancedSettingsTab": "Paramètres avancés",
  "buttons.selectFiles": "Sélectionner des fichiers",
  "buttons.generateSummary": "Générer un résumé avec l’IA",
  "labels.createOrganization": "Créer une organisation",
  "labels.updateOrganization": "Mettre à jour l'organisation",
  "labels.organizationId": "Identifiant de l'organisation",
  "buttons.generatingSummary": "Génération...",
  "buttons.createKnowledge": "Créer une base de connaissances",
  "buttons.updateKnowledge": "Mettre à jour la base de connaissances",
  "buttons.creatingInProgress": "Création en cours...",
  "buttons.updatingInProgress": "Mise à jour en cours...",
  "sideBarLabels.organizations": "Organisations",
  "sideBarLabels.explainability": "Explicabilité",

  "buttons.next": "Suivant",
  "buttons.back": "Retour",
  "buttons.webUrl": "URL Web",
  "buttons.AddGroupButton": "Ajouter",
  "buttons.signingInButton": "Connexion en cours...",
  "buttons.signInButton": "Se connecter",
  "buttons.uploadFiles":
    "Cliquez pour sélectionner des fichiers ou glissez-déposez",
  "buttons.addQuery": "Ajouter une requête",
  "buttons.copyQuery": "Copier la requête",
  "buttons.useQuery": "Utiliser la requête",
  "buttons.createQuery": "Créer une requête",
  "buttons.updateQuery": "Mettre à jour la requête",
  "buttons.refresh": "Actualiser",
  "buttons.exportReport": "Exporter le rapport",
  "buttons.close": "Fermer",
  "buttons.createUser": "Créer un utilisateur",
  "buttons.updateUser": "Mettre à jour l’utilisateur",
  "buttons.search": "Rechercher",
  "buttons.updateVersionButton": "Mettre à jour la version",

  "actions.view": "Voir",
  "actions.edit": "Modifier",
  "actions.delete": "Supprimer",
  "actions.close": "Fermer",
  "actions.confirm": "Confirmer",
  "actions.cancel": "Annuler",
  "actions.create": "Créer",
  "actions.selectAll": "Tout sélectionner",
  "actions.deleteVersion": "Supprimer la version",
  "actions.deleteTemplate": "Supprimer le modèle",

  "formValidationErrors.templateName": "Le nom du modèle est obligatoire.",
  "formValidationErrors.role": "Le rôle est obligatoire.",
  "formValidationErrors.task": "La tâche est obligatoire.",

  "sideBarLabels.playground": "Terrain d’essai",
  "sideBarLabels.chatInterface": "Interface de chat",
  "sideBarLabels.userManagement": "Gestion des utilisateurs",
  "sideBarLabels.groups": "Groupes",
  "sideBarLabels.aiMetrics": "Métriques IA",
  "sideBarLabels.knowledgeStore": "Magasin de connaissances",
  "sideBarLabels.prompts": "Invites",
  "sideBarLabels.settings": "Paramètres",
  "sideBarLabels.logout": "Se déconnecter",
  "sideBarLabels.user": "Utilisateur",
  "sideBarLabels.aiSettings": "Paramètres IA",
  "sideBarLabels.appearance": "Apparence",
  "sideBarLabels.admin": "Admin",
  "sideBarLabels.queryLibrary": "Bibliothèque de requêtes",
  "sideBarLabels.governanceDashboard": "Tableau de gouvernance",
  "sideBarLabels.performanceDashboard": "Tableau de bord des performances",
  "sideBarLabels.agents": "Agents",
  "sideBarLabels.userAdoptionInsights": "Aperçus du projet",
  "sideBarLabels.feedbackReport": "Rapport de feedback",

  "appLabels.appName": "GenAI Studio",
  "appLabels.appDescription":
    "Concevoir, tester et surveiller des applications basées sur GenAI.",

  "titles.name": "Nom",
  "titles.version": "Version",
  "titles.id": "ID",
  "titles.email": "Adresse e-mail",
  "titles.organization": "Organization",
  "titles.groups": "Groupes",
  "titles.roles": "Rôle",
  "titles.task": "Tâche",
  "titles.requirements": "Exigences",
  "titles.details": "Détails supplémentaires",
  "titles.restrictions": "Restrictions",
  "titles.format": "Format de sortie",
  "titles.examples": "Exemples et échantillons",
  "titles.updated": "Mis à jour",
  "titles.actions": "Actions",
  "titles.knowledgeStore": "Magasin de connaissances",
  "titles.knowledgeBase": "Bases de connaissances",
  "titles.chatConfiguration": "Configuration du chat",
  "titles.promptTemplates": "Modèles de prompts",
  "titles.summary": "Résumé",
  "titles.groupManagement": "Gestion des groupes",
  "titles.recordDetails": "Détails de l'enregistrement",
  "titles.aiMetrics": "Métriques RAI",
  "titles.hapDetection": "Détection HAP",
  "titles.hapSubtitle": "Haine, abus, propos offensants",
  "titles.piiDetection": "Détection des données personnelles",
  "titles.piiSubtitle": "Informations personnelles",
  "titles.latency": "Latence",
  "titles.latencySubtitle": "Latence moyenne des chats (ms)",
  "titles.throughput": "Débit",
  "titles.throughputSubtitle": "Requêtes de chat par seconde",
  "titles.contextDrift": "Dérive contextuelle",
  "titles.responseDrift": "Dérive de réponse",
  "titles.accuracy": "Précision",
  "titles.contextDriftSubtitle": "Score moyen de dérive contextuelle (0-1)",
  "titles.responseDriftSubtitle": "Score moyen de dérive de réponse (0-1)",
  "titles.accuracySubtitle": "Score moyen de précision (0-1)",
  "titles.retrievalPrecisionSubtitle": "Score moyen de précision de récupération (0-1)",
  "titles.input": "Entrée",
  "titles.output": "Sortie",
  "titles.tokenMetrics": "Métriques des jetons",
  "titles.biasDetection": "Détection des biais",
  "titles.relevancyScore": "Score de pertinence",
  "titles.precisionScore": "Score de précision",
  "titles.comingSoon": "Bientôt disponible",
  "titles.feedbackResults": "Résultats des retours",
  "titles.manageOrganization": "Gérer l'organisation",
  "titles.sysAdminProvisioning": "Provisionnement de l'administrateur système",
  "descriptions.sysAdminProvisioning":
    "En tant qu'administrateur système, vous pouvez créer, mettre à jour, consulter et supprimer des organisations, en gérant l'intégralité de leur cycle de vie au sein du système.",
  "titles.conversationAnalysis": "Analyse de conversation",
  "titles.temperature": "Température",
  "titles.topP": "Top-P",
  "titles.topK": "Top-K",
  "titles.maxInputTokens": "Nombre maximal de tokens d'entrée",
  "titles.maxOutputTokens": "Nombre maximal de tokens de sortie",
  "titles.stopSequence": "Séquence d'arrêt",
  "titles.guidelines": "Directives",
  "titles.technicalParameters": "Paramètres techniques",
  "titles.queryLibrary": "Bibliothèque de requêtes",
  "titles.governanceDashboard": "Tableau de gouvernance",
  "titles.performanceDashboard": "Tableau de bord des performances",
  "titles.userAdoptionInsights": "Aperçus du projet",
  "titles.liveAnalysis": "Analyse en direct",
  "titles.feedback": "Retour d'expérience",
  "titles.feedbackDetails": "Détails du retour",
  "titles.feedbackReport": "Rapport de retour",
  "titles.copyToClipboard": "Copier dans le presse-papiers",
  "titles.copied": "Copié !",
  "titles.select.agent": "Sélectionnez un agent",
  "titles.selectModel": "Sélectionner un Modèle",
  "titles.contextRelevancy": "Pertinence du Contexte",
  "titles.answerRelevancy": "Pertinence de la Réponse",
  "titles.retrievalPrecision": "Précision de Récupération",
  "titles.sentiment": "Sentiment",
  "titles.hallucination": "Hallucination",
  "titles.updateGroup": "Mettre à jour le groupe",
  "titles.createUser": "Créer un utilisateur",
  "titles.orgAdminProvisioning":
    "Provisionnement de l’administrateur d’organisation",
  "titles.updateUser": "Mettre à jour l’utilisateur",
  "titles.viewUser": "Détails de l’utilisateur",

  "errors.validation.notBlank.fieldName": "{{fieldName}} is required",
  "errors.groupNameRequired": "Group name is required",
  "errors.groupDescriptionRequired": "Group description is required",
  "sessionExpiryModal.title": "Session bientôt expirée",
  "sessionExpiryModal.message":
    "Votre session est sur le point d'expirer. Prolongez-la pour continuer à travailler sans interruption.",
  "sessionExpiryModal.extendButton": "Prolonger la session",
  "sessionExpiryModal.extendingButton": "Extension de la session",
  "sessionExpiryModal.remaining": "restant",

  "validation.firstNameRequired": "Le prénom est requis",
  "validation.lastNameRequired": "Le nom est requis",
  "validation.emailRequired": "L'email est requis",
  "validation.emailInvalid": "Adresse email invalide",
  "validation.passwordRequired": "Le mot de passe est requis",
  "validation.passwordInvalid":
    "Le mot de passe doit contenir au moins 8 caractères et inclure une majuscule, une minuscule, un chiffre et un caractère spécial",
  "validation.roleRequired": "Le rôle est requis",
  "validation.organizationRequired": "L'organisation est requise",
  "validation.groupRequired": "Le groupe est requis",
  "validation.knowledgeNameRequired": "Le nom du document est requis",
  "validation.departmentNameRequired": "Le nom du département est requis",
  "validation.documentNumberRequired": "Le numéro du document est requis",
  "validation.documentDateRequired": "La date du document est requise",
  "validation.agentRequired": "L'agent est requis",
  "validation.embeddingProviderRequired":
    "Le fournisseur d'embedding est requis",
  "validation.embeddingModelRequired": "Le modèle d'embedding est requis",
  "labels.activity": "Activité récente",
  "labels.sources": "Références",
  "labels.activity.notFound": "Aucune activité enregistrée pour cette réponse.",
  "labels.sources.notFound": "Aucune source référencée pour cette réponse.",
  "labels.aiGeneratedContent": "Contenu généré par IA · peut ne pas toujours être exact.",
  "labels.explainability": "Explicabilité",
  "labels.followupQuestions": "Questions de suivi suggérées :",
  "toastMessages.failedToGetMessage": "Impossible de récupérer le message.",
  "toastMessages.serverError": "Quelque chose s'est mal passé",
  "toastMessageDescriptions.serverError": "Nous n'avons pas pu traiter votre demande. Veuillez réessayer plus tard.",
  "toastMessageDescriptions.chatErrorUser": "Une erreur s'est produite lors de la récupération de votre réponse. Essayez de reformuler votre question ou revenez dans un moment — il peut s'agir d'un problème temporaire de notre côté.",
  "toastMessageDescriptions.chatErrorAdmin": "Une erreur s'est produite lors de la récupération de votre réponse. Essayez de reformuler votre question ou vérifiez votre modèle de prompt pour détecter des incohérences. Si le problème persiste, revenez dans un moment — il peut s'agir d'une perturbation temporaire.",
  "labels.userQueryPiiMasking": "Protection de vos informations...",
  "labels.semanticCacheSearch": "Recherche d’informations connexes...",
  "labels.inputGuardrailsValidation":
    "Validation de la sécurité de la requête...",
  "labels.documentRetrieval": "Exploration de la base de connaissances...",
  "labels.chainStreamingResponse": "Génération de votre réponse...",
  "labels.responsePiiMasking": "Sécurisation des données de réponse...",
  "labels.outputGuardrailsValidation":
    "Vérification de la qualité de la réponse...",
  "labels.generateSources": "Compilation des références...",
  "labels.generateFollowUpQuestions":
    "Préparation de suggestions complémentaires...",
  "labels.promptTemplateMessage": "Organisation de votre demande...",
  "labels.completed": "Terminé",
  "labels.chat.configure": "Configurer le chat pour démarrer la conversation",
  "titles.chat.heading": "🤖 Bonjour,",
  "titles.chat.subHeading": "Comment puis-je vous aider ?",
  "titles.chat.description":
    "Configurez votre chat en sélectionnant un agent, un modèle, une base de connaissances et un modèle de prompt dans le panneau de droite.",
  "chat.disclaimer":
    "Ce contenu est généré par une intelligence artificielle et peut parfois être incorrect.",
};
